import { Flex } from '@chakra-ui/react';
import styled from 'styled-components';

const TypingDot = styled.div`
    width: 6px;
    height: 6px;
    margin: 0 2px;
    background: white;
    border-radius: 50%;
    opacity: 0;
    animation: loadingFade 1s infinite;
    &:nth-child(1) {
        animation-delay: 0s;
    }
    &:nth-child(2) {
        animation-delay: 0.2s;
    }
    &:nth-child(3) {
        animation-delay: 0.4s;
    }
    @keyframes loadingFade {
        0% {
            opacity: 0;
        }
        50% {
            opacity: 0.8;
        }
        100% {
            opacity: 0;
        }
    }
`;

export const TypingDots = ({ ...props }) => (
    <Flex border='1px solid #5611F8' w='fit-content' p='5px' borderRadius='8px' bgColor='#5611F8' {...props}>
        <TypingDot />
        <TypingDot />
        <TypingDot />
    </Flex>
);
